import React, { useState } from 'react';
import { MethodEnum } from 'axios/type';
import useAxios from 'axios/useAxios';
import { formatDate, dateStrParse } from 'components/DatePicker/consts';
import DateEnum from 'components/DatePicker/enum';
import Rim from 'components/_form/Rim';
import TableTit from 'components/_form/TableTit';
import { showResponseSnackBar } from 'consts';
import ButtonVariantEnum from 'tradevan-ui/Button/enum';
import { inputVal, classCombine } from 'tradevan-ui/consts';
import {
  EnumDocType,
  EnumRetailerSetup,
  EnumMasterSort,
  EnumFunctionId,
} from 'view/Layout/enum';
import { TableProps } from 'components/Table/type';
import Button from 'tradevan-ui/Button';
import Table from 'components/Table';
import PDFReader, { PDFReaderProps } from 'components/PDFReader';
import DownloadPdfButton from 'view/Layout/Project/components/downloadPdfButton';
import CopyButton from 'view/Layout/components/CopyDiv';
import Modal from 'tradevan-ui/Modal';
import StatusEnum from 'axios/enum';
import {
  IqueryReportSettingRequest,
  IqueryReportSettingResponse,
} from 'view/Layout/type';
import { Idetail, EnumDetail, EnumMaster } from '../../init';
import {
  IlogRecordQueryRequest,
  IlogRecordQueryResponse,
  IreturnsDownloadPreviewRequest,
  ResultSecionProps,
  ReturnsDownloadPreviewRequest,
} from './type';
import DownloadPdf from './components/DownloadPdf';
import { getColumns } from './consts';

const ResultSecion = (props: ResultSecionProps) => {
  const {
    handleSearch,
    formReturnDetail,
    userInfoReducer,
    _retailerSetup: [retailerSetup],
    _showLogRecordModal: [, setShowLogRecordModal],
    _logRecordData: [, setLogRecordData],
  } = props;
  const axios = useAxios();
  /** 預覽檔案 */
  const [pdfObj, setPdfObj] = useState<PDFReaderProps>({
    show: false,
    file: '',
    onClose: () =>
      setPdfObj((prev: PDFReaderProps) => ({ ...prev, show: false })),
  });

  const {
    watch,
    setValue,
    handleSubmit,
    setValue: setValueDetail,
  } = formReturnDetail;

  const master = watch('master');
  const detail = watch('detail');
  const pageObj = watch('pageObj');
  const masterSort = watch('masterSort');

  /** 控制Modal視窗開關 */
  const [openDialog, setOpenDialog] = useState(false);
  // 報表類別
  const [returnType, setReturnType] = useState('');
  /** 儲存rptType，提供Modal視窗後使用 */
  // const [rptType4Modal, setrptType4Modal] = useState('');
  /** 儲存message，提供Modal視窗後使用 */
  const [message, setmessage] = useState('');
  /** 控制預覽視窗是否要出現 */
  // const [showPreview, setshowPreview] = useState(true);
  // 是否開啟詢問視窗
  const [askPriceShowModal, setShowModal] = useState(false);
  // 判斷預覽、下載
  const [triggerAction, setTriggerAction] = useState<string | null>(null);
  // 紀錄Row 的參數
  const [selectedRow, setSelectedRow] = useState<Idetail | null>(null);

  // let request: IreturnsDownloadPreviewRequest;

  /** 點閱紀錄 資料查詢 */
  const getLogRecord = async (row: Idetail) => {
    const response = await axios.doAxios<
      IlogRecordQueryRequest,
      IlogRecordQueryResponse
    >(MethodEnum.post, 'logRecord/query', {
      retailerId: row[EnumDetail.retailerId],
      actionType: '',
      docType: EnumDocType.退貨,
      docNo: row[EnumDetail.returnNo],
      docSeqNo: row[EnumDetail.returnSeqNo],
    });
    if (response) {
      const { data } = response.data;
      setLogRecordData(data.contents.map((v, i) => ({ ...v, id: String(i) })));
      setShowLogRecordModal(true);
      showResponseSnackBar(response.data);
    }
  };

  // 批次下載PDF
  const downloadReport = async (
    rptType: string,
    inputPreviewShowPrice: boolean,
    inputDownloadShowPrice: boolean,
  ) => {
    const request = {
      [ReturnsDownloadPreviewRequest.rptType]: rptType,
      [ReturnsDownloadPreviewRequest.retailerId]: master[EnumMaster.retailerId],
      [ReturnsDownloadPreviewRequest.returnSeqNos]: detail
        .filter((v) => v.selected)
        .map((v) => v[EnumDetail.returnSeqNo]),
      [ReturnsDownloadPreviewRequest.sort]: masterSort
        .filter((v) => v[EnumMasterSort.property] !== '')
        .map((v) => ({
          ...v,
          [EnumMasterSort.desc]: v.desc ? 'Y' : 'N',
        })),
      [ReturnsDownloadPreviewRequest.previewShowPrice]:
        inputPreviewShowPrice || false,
      [ReturnsDownloadPreviewRequest.downloadShowPrice]:
        inputDownloadShowPrice || false,
    };
    if (request.returnSeqNos.length > 0) {
      const response = await axios.blobAxios<IreturnsDownloadPreviewRequest>(
        MethodEnum.post,
        'returns/download',
        request,
      );
      axios.blobDownload(response);
    }

    handleSubmit(handleSearch())();
  };

  // 預覽列印(單筆/批次)
  const previewReport = async (
    rptType: string,
    row?: Idetail,
    inputPreviewShowPrice?: boolean,
    inputDownloadShowPrice?: boolean,
  ) => {
    const request = {
      [ReturnsDownloadPreviewRequest.rptType]: rptType,
      [ReturnsDownloadPreviewRequest.retailerId]: master[EnumMaster.retailerId],
      [ReturnsDownloadPreviewRequest.returnSeqNos]: row
        ? [row[EnumDetail.returnSeqNo]]
        : detail
            .filter((v) => v.selected)
            .map((v) => v[EnumDetail.returnSeqNo]),
      [ReturnsDownloadPreviewRequest.sort]: masterSort
        .filter((v) => v[EnumMasterSort.property] !== '')
        .map((v) => ({
          ...v,
          [EnumMasterSort.desc]: v.desc ? 'Y' : 'N',
        })),
      [ReturnsDownloadPreviewRequest.previewShowPrice]:
        inputPreviewShowPrice || false,
      [ReturnsDownloadPreviewRequest.downloadShowPrice]:
        inputDownloadShowPrice || false,
    };
    if (request.returnSeqNos.length > 0) {
      const response = await axios.blobAxios<IreturnsDownloadPreviewRequest>(
        MethodEnum.post,
        'returns/preview',
        request,
      );
      setPdfObj((prev: PDFReaderProps) => ({
        ...prev,
        show: true,
        file: window.URL.createObjectURL(response.data),
        customChild: <DownloadPdfButton pageName="returns" request={request} />,
      }));
    }
  };

  // 判斷報表是要進行預覽、還是下載
  function handleReportProcess(
    rptTypetemp: 'RTN' | 'RTN_NOTE',
    action: string,
    inputRow: Idetail | null,
    inputPreviewShowPrice: boolean,
    inputDownloadShowPrice: boolean,
  ) {
    // 根據 action 判斷是 preview 還是 download
    if (action === 'preview' && inputRow !== null) {
      previewReport(
        rptTypetemp,
        inputRow,
        inputPreviewShowPrice,
        inputDownloadShowPrice,
      );
    } else if (action === 'preview' && inputRow === null) {
      previewReport(
        rptTypetemp,
        undefined,
        inputPreviewShowPrice,
        inputDownloadShowPrice,
      );
    } else if (action === 'download') {
      downloadReport(
        rptTypetemp,
        inputPreviewShowPrice,
        inputDownloadShowPrice,
      );
    } else {
      console.error('Action Type is error');
    }
  }
  // 判斷是否跳出詢問單價視窗
  function handleAckDialog(
    rptTypetemp: 'RTN' | 'RTN_NOTE',
    askUser: boolean,
    action: string,
    inputRow: Idetail | null,
    inputPreviewShowPrice: boolean,
    inputDownloadShowPrice: boolean,
  ) {
    if (askUser) {
      setShowModal(true);
    } else {
      handleReportProcess(
        rptTypetemp,
        action,
        inputRow,
        inputPreviewShowPrice,
        inputDownloadShowPrice,
      );
    }
  }

  // 是否列印單價詢問視窗：選擇[顯示]價格
  const handleAskPriceConfirm = async () => {
    // 關閉視窗
    setShowModal(false);

    if (triggerAction !== null) {
      handleReportProcess(
        returnType as 'RTN' | 'RTN_NOTE',
        triggerAction,
        selectedRow,
        true,
        true,
      );
    }
    setTriggerAction(null); // 重置觸發動作
  };

  // 是否列印單價詢問視窗：選擇[不]顯示價格,或右上角X關閉視窗
  const handleAskPriceCancel = async () => {
    // 關閉視窗
    setShowModal(false);

    if (triggerAction !== null) {
      handleReportProcess(
        returnType as 'RTN' | 'RTN_NOTE',
        triggerAction,
        selectedRow,
        false,
        false,
      );
    }
    setTriggerAction(null); // 重置觸發動作
  };

  const checkAskPrice = async (
    rptTypetemp: 'RTN' | 'RTN_NOTE',
    row?: Idetail,
    actionType?: 'preview' | 'download',
  ) => {
    // 儲存 row 的資料
    setSelectedRow(row !== undefined ? row : null);

    // 儲存returnType
    setReturnType(rptTypetemp);
    const responseQueryReportSetting = await axios.doAxios<
      IqueryReportSettingRequest,
      IqueryReportSettingResponse
    >(MethodEnum.post, 'retailerSetup/queryReportRetailerSetup', {
      retailerId: master[EnumMaster.retailerId],
      role: userInfoReducer.role,
      functionId: EnumFunctionId.退貨單,
    });

    if (
      responseQueryReportSetting &&
      responseQueryReportSetting.data.data &&
      responseQueryReportSetting.data.status === StatusEnum.完成
    ) {
      const { data } = responseQueryReportSetting.data;

      setTriggerAction(actionType || '');
      // console.log('actionType==>', actionType);
      handleAckDialog(
        rptTypetemp,
        data.retailerSetup.showPriceCode.askUser,
        actionType || '',
        row !== undefined ? row : null,
        data.retailerSetup.showPriceCode.previewShowPrice,
        data.retailerSetup.showPriceCode.downloadShowPrice,
      );
    }
  };

  // 檢查是否有退貨驗收資料
  const checkReceiveNoExists = async (
    rptTypetemp: 'RTN' | 'RTN_NOTE',
    row?: Idetail,
    actionType?: 'preview' | 'download',
  ) => {
    // console.log('checkReceiveNoExists==>', rptTypetemp);
    if (row === undefined && rptTypetemp === 'RTN') {
      const noReceiveList = row
        ? [row[EnumDetail.returnSeqNo]]
        : detail
            .filter((v) => v.selected && v[EnumDetail.returnNo] === null)
            .map((v) => v[EnumDetail.returnNoteNo]);
      if (noReceiveList.length > 0) {
        let messagetemp = '';
        for (let i = 0; i < noReceiveList.length; i += 1) {
          messagetemp += `\n${noReceiveList[i]}`;
          if (i < noReceiveList.length - 1) {
            messagetemp += ',';
          }
        }
        setmessage(
          `下列退貨單通知單號碼未驗收，無法預覽退貨驗收單:${messagetemp}`,
        );

        /* 重新設定detail，原有被勾選且returnNo不為null，方可勾選，其餘取消勾選 */
        setValueDetail(
          'detail',
          detail.map((v) => ({
            ...v,
            selected: v.selected === true && v[EnumDetail.returnNo] !== null,
          })),
        );
        setOpenDialog(true);
      } else {
        // 檢核通過，進行預覽或下載

        checkAskPrice(rptTypetemp, row, actionType);
      }
    } else {
      // 退貨通知下載/預覽
      checkAskPrice(rptTypetemp, row, actionType);
    }
  };
  /** Table 資料異動事件 */
  const handleDataChange: TableProps<Idetail>['onDataChange'] = (
    rows,
    rowStart,
    rowEnd,
  ) => {
    setValue(
      'detail',
      detail.map((obj, idx) =>
        idx >= rowStart && idx <= rowEnd ? rows[idx - rowStart] : obj,
      ),
    );
  };

  const renderCell: TableProps<Idetail>['renderCell'] = (params) => {
    const { field, row, value } = params;
    /** 日期格式轉換 */
    const converDate = (
      dateStr: string,
      targetDateFormat: DateEnum,
      returnDateFormat: DateEnum,
    ) => {
      return formatDate(returnDateFormat)(
        dateStrParse(targetDateFormat)(inputVal(dateStr)),
      );
    };

    switch (field) {
      /** 點閱紀錄 */
      case EnumDetail.viewed:
        return (
          <Button
            style={{ fontSize: 14 }}
            variant={ButtonVariantEnum.link}
            onClick={(e) => {
              e.stopPropagation();
              getLogRecord(row);
            }}
          >
            {value}
          </Button>
        );
      /** 退貨通知單號碼(打開預覽列印) */
      case EnumDetail.returnNoteNo:
        return (
          <CopyButton
            text={value}
            onClick={(e) => {
              e.stopPropagation();
              // pdfPreview('RTN_NOTE', row);
              checkAskPrice('RTN_NOTE', row, 'preview');
            }}
          />
        );
      /** 退貨驗收單號碼 (打開預覽列印) */
      case EnumDetail.returnNo:
        return (
          <CopyButton
            text={value}
            onClick={(e) => {
              e.stopPropagation();
              // pdfPreview('RTN', row);
              checkAskPrice('RTN', row, 'preview');
            }}
          />
        );
      /** 分店/倉庫名稱 */
      case EnumDetail.buyerGLN:
        return (
          <>
            {inputVal(value)}
            {!!value && <br />}
            {inputVal(row[EnumDetail.postBriefName])}
          </>
        );
      /** 退貨驗收日期 */
      case EnumDetail.returnDate:
      case EnumDetail.returnNoteDate:
      case EnumDetail.deliverEndDate:
        return converDate(value, DateEnum.yyyyMMdd, DateEnum['yyyy/MM/dd']);

      case EnumDetail.updDate: {
        return inputVal(
          converDate(
            value,
            DateEnum.yyyyMMddHHmmss,
            DateEnum['yyyy/MM/dd HH:mm:ss'],
          ),
        );
      }

      default:
        break;
    }
    return undefined;
  };

  return (
    <>
      <PDFReader
        {...pdfObj}
        onClose={() => {
          handleSubmit(handleSearch(pageObj.pageNo, pageObj.pageSize))();
          setPdfObj((prev: PDFReaderProps) => ({ ...prev, show: false }));
        }}
      />
      <TableTit>
        <span>查詢結果</span>
        <DownloadPdf
          retailerSetup={retailerSetup}
          handleSearch={handleSearch}
          checkReceiveNoExists={checkReceiveNoExists}
          formReturnDetail={formReturnDetail}
        />
      </TableTit>
      <Rim>
        <div
          style={{ overflowY: 'hidden' }}
          className={classCombine('table-responsive', 'has-foot')}
        >
          <Table
            serverRender
            tableClass={classCombine('table', 'tb-multi')}
            hover={false}
            renderCell={renderCell}
            data={detail.map((v, i) => ({ ...v, id: i }))}
            columns={getColumns(retailerSetup[EnumRetailerSetup.queryResults])}
            page={pageObj.pageNo}
            pageSize={pageObj.pageSize}
            totalCount={pageObj.total}
            onPageChange={async (pageNo, pageSize) => {
              await handleSubmit(handleSearch(pageNo, pageSize))();
            }}
            onDataChange={handleDataChange}
          />
        </div>
      </Rim>
      <Modal
        backdrop="static"
        header={<b style={{ color: 'white' }}>提示訊息</b>}
        scrollable
        closeButton={false}
        show={openDialog}
        onHide={() => {
          setOpenDialog(false);
        }}
        footer={
          <Button
            onClick={() => {
              // requsetAPI4Modal();
              setOpenDialog(false);
            }}
          >
            確定
          </Button>
        }
      >
        <p>{message}</p>
      </Modal>
      <Modal
        show={askPriceShowModal}
        onHide={handleAskPriceCancel}
        header={<b style={{ color: 'white' }} />}
        footer={
          <>
            <Button type="button" onClick={handleAskPriceConfirm}>
              列印單價
            </Button>
            <Button type="button" onClick={handleAskPriceCancel}>
              不印單價
            </Button>
          </>
        }
      >
        請問報表是否顯示單價?
      </Modal>
    </>
  );
};
export default ResultSecion;
